import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setIsContrast } from '../../../redux/generalReducer';
import Const from '../../../const.json'
import './ContrastToggle.scss';

const ContrastToggle: React.FC = () => {

  const dispatch = useAppDispatch();
  const {isContrast} = useAppSelector(state => state.general);

  const toggleContrast = () => {
    document.body.classList.toggle('high-contrast');
    dispatch(setIsContrast(!isContrast));
  };

  return (
    <button className='btnContrast' onClick={toggleContrast} tabIndex={0}>
      {Const.contrastToggle}
    </button>
  );
};

export default ContrastToggle;
